import type { ProcessedSpectator } from "@/local-shared/model";
import { SUCCESS, type SocialAPI } from ".";

export default class RoomAPI
{
    public constructor(private api: SocialAPI)
    {
        Logger.log(this.api);
    }

    public async addSpectator(roomId: string): Promise<{
        spectatorId: number;
    }>
    {
        Logger.log("Adding spectator", { roomId });

        const response = await this.api.fetch<{
            spectatorId: string;
        }>("/rooms/spectator/add", {
            method: "POST",
            body: JSON.stringify({ roomID: roomId }),
        });

        if (response.status !== SUCCESS)
        {
            Logger.error("Room API", `Failed to add spectator: ${response.status} ${response.message}`);

            throw new Error(`Failed to add spectator: ${response.message}`);
        }

        Logger.log("Spectator added successfully");

        if (!response.data?.spectatorId)
        {
            Logger.error("Room API", "No spectator ID returned in response data");

            throw new Error("No spectator ID returned in response data");
        }

        return {
            spectatorId: parseInt(response.data.spectatorId, 10),
        };
    }

    public async removeSpectator(spectatorId: number): Promise<void>
    {
        Logger.log("Removing spectator", { spectatorId });

        const response = await this.api.fetch("/rooms/spectator/remove", {
            method: "POST",
            body: JSON.stringify({ spectatorID: spectatorId }),
        });

        if (response.status !== SUCCESS)
        {
            Logger.error("Room API", `Failed to remove spectator: ${response.status} ${response.message}`);

            throw new Error(`Failed to remove spectator: ${response.message}`);
        }

        Logger.log("Spectator removed successfully");
    }

    public async getSpectators(roomId: string): Promise<{
        spectators: ProcessedSpectator[];
    }>
    {
        Logger.log("Getting spectators for room", { roomId });

        const response = await this.api.fetch<{
            spectators: ProcessedSpectator[];
        }>("/rooms/spectator/list", {
            method: "POST",
            body: JSON.stringify({ roomID: roomId }),
        });

        if (response.status !== SUCCESS)
        {
            Logger.error("Room API", `Failed to get spectators: ${response.status} ${response.message}`);

            throw new Error(`Failed to get spectators: ${response.message}`);
        }

        Logger.log("Spectators retrieved successfully");

        return { spectators: response.data?.spectators ?? [] };
    }
}
